/**
 * Extract a readable error message from an axios error response.
 * Handles all our backend shapes:
 *  - 400 {detail: "plain string"}
 *  - 400 {detail: {field, errors: [{code, message}, ...]}}
 *  - 400 {detail: {errors: [...]}}
 *  - 422 {detail: [{loc, msg, type}, ...]}  (pydantic)
 *  - fallback
 */
export function extractError(err, fallback = "Something went wrong.") {
    const detail = err?.response?.data?.detail;
    if (!detail && err?.message) return err.message;
    if (!detail) return fallback;

    if (typeof detail === "string") return detail;

    // Pydantic validation list
    if (Array.isArray(detail)) {
        const msgs = detail
            .map((d) => (d?.msg ? (d.loc ? `${d.loc.slice(-1)[0]}: ${d.msg}` : d.msg) : null))
            .filter(Boolean);
        if (msgs.length) return msgs.join(" · ");
    }

    // Our structured photo / skin-tone error
    if (detail && typeof detail === "object") {
        if (Array.isArray(detail.errors) && detail.errors.length) {
            const first = detail.errors[0];
            const prefix = detail.field ? `${detail.field.replace("_", " ")}: ` : "";
            return prefix + (first.message || first.code || JSON.stringify(first));
        }
        // Generic object: stringify a short form
        try {
            return JSON.stringify(detail).slice(0, 220);
        } catch {
            return fallback;
        }
    }
    return fallback;
}
